/**
 * The model picker's groups (ADMIN-212): one per provider, from the `provider` field of
 * `/api/config/models`, in the order the API lists them. A model without a provider (an old
 * cache) goes in "Other", last.
 */

export type GroupableModel = {
  id: string;
  provider?: { id: string; name: string; logo?: string } | undefined;
};

export type ModelGroup<T extends GroupableModel> = {
  provider: { id: string; name: string; logo?: string };
  models: T[];
};

const OTHER = { id: "other", name: "Other" };

export function groupModelsByProvider<T extends GroupableModel>(
  models: readonly T[],
): ModelGroup<T>[] {
  const groups = new Map<string, ModelGroup<T>>();
  for (const model of models) {
    const provider = model.provider ?? OTHER;
    let group = groups.get(provider.id);
    if (!group) {
      group = { provider, models: [] };
      groups.set(provider.id, group);
    }
    group.models.push(model);
  }
  const other = groups.get(OTHER.id);
  if (other) {
    groups.delete(OTHER.id);
    groups.set(OTHER.id, other);
  }
  return [...groups.values()];
}
